document.addEventListener('click', ({ target }) => {
  if (!target.matches('.event-modal__close')) return;
  document.querySelector('.event-modal').classList.remove('event-modal--active');
  document.querySelector('body').classList.remove('menu-is-open');
});

document.addEventListener('click', ({ target }) => {
  if (!target.matches('.event-modal-button')) return;
  document.querySelector('.event-modal').classList.add('event-modal--active');
  document.querySelector('body').classList.add('menu-is-open');
});
